import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

import { getPathFromModel } from '../../../utils/link';
import { truncate } from '../../../utils/string';

import {
	StyledGridItem,
	StyledHeader,
	StyledItemContainer,
	StyledItemImage,
	StyledItemThumbnail
} from './block-link-list.styles';

import { ThemeProvider } from 'styled-components';
import { THEME_DARK, THEME_WHITE } from '../../../theme/theme';
import { ItemContent } from '../item-content';



import GridContainer from '../grid-container';


const BlocklListItem = ({ title, label, image, banner, description, topic, model, slug, images, property, name, introduction }) => {

	const img = images && images.length > 0 ? images[0] : (banner || image);

	return (
		<StyledItemContainer to={getPathFromModel({ model, slug })}>
			<StyledItemThumbnail>
				{img && <StyledItemImage as={GatsbyImage} image={img.gatsbyImageData} alt={img.alt || ""} objectFit="cover" objectPosition="50% 50%" />}
			</StyledItemThumbnail>
			<ItemContent label={property?.name || topic?.name || label} heading={name || title} description={truncate(description || introduction, 50)} />
		</StyledItemContainer>
	)
}

const BlockListGrid = ({
	items
}) => {
	return (
		<>
			{items.map((item) => <StyledGridItem><BlocklListItem {...item} /></StyledGridItem>)}
		</>
	)
};

const BlockLinkList = ({
	index, dark, label, heading, items, spaceBefore, extraSpaceBefore, extraSpaceAfter
}) => {

	return (
		<ThemeProvider theme={dark ? THEME_DARK : THEME_WHITE}>
			<GridContainer index={index} spaceBefore={spaceBefore} extraSpaceBefore={extraSpaceBefore} extraSpaceAfter={extraSpaceAfter} verticalSpace='medium'>
				{heading && <StyledHeader heading={heading} label={label} />}
				<BlockListGrid items={items} />
			</GridContainer>
		</ThemeProvider >
	)
};

export default BlockLinkList;
